import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { captureError } from '@leagueplatform/observability';
import type { UserProfileAggregate } from '@leagueplatform/user-profile-api';
import { saveMemberProfileSection } from '../../domain/profile/profile-wire';
import type { SectionValues } from '../../domain/profile/profile-types';

export const submitAccountSetup = async (
  contactInformation: SectionValues,
  aggregate: UserProfileAggregate | null,
  marketingOptIn: boolean,
): Promise<void> => {
  const savePromise = saveMemberProfileSection(
    'contactInformation',
    contactInformation,
    aggregate,
  );

  // marketing_opt_in has no confirmed BE field yet; best-effort, non-blocking,
  // and run concurrently with the save above rather than delaying it.
  SocketAsFetch.fetch({
    message_type: 'set_user_profile',
    info: { marketing_opt_in: marketingOptIn },
  }).catch((error) => {
    captureError(
      error instanceof Error
        ? error
        : new Error('account setup marketing opt-in failed'),
    );
  });

  await savePromise;
};
